import { Help, HelpParameters, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { RewardColor } from "../../slot/ScatterRandomAward/RewardOptionFactory";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { ButtonColors, Panel } from "../panel/panel";
import { PickBonus, PickBonusFactory } from "../PickBonus/PickBonus";
import { PickBonusElement } from "../PickBonus/PickBonusElement";
import { PickBonusParams, PickBonusPickElementParams } from "../PickBonus/PickBonusParams";
import { SlotGameType1 } from "../SlotGameType1";


// namespace SlotGames {

	export class LuckyHot extends SlotGameType1 {
		protected override pickBonusFactory:PickBonusFactory = new LuckyHotPickBonusFactory();
		////protected override freegameBonusFactory: FreegameBonusFactory = new LuckyHotFreegameBonusFactory();
		
		protected override panelFactory:IPanelFactory = new LuckyHotPanelFactory();
		protected override helpFactory: IHelpFactory = new LuckyHotHelpFactory();
		
		//SEND COLOR 
        protected override color: RewardColor = 
        {
            color: "white",
		    coloroutherStroke: "black",
            colorinnerStroke: "darkred",
        }

		//LED COLOR
		protected override ColorLed:string="250,0,0\n";


		
		constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
			super(multigameParams, initData, "LuckyHot");
			this.spinnableReelsParams.topBorderWidth = 21;
			this.spinnableReelsParams.bottomBorderWidth = 13;
		}
		
	
	}


	//Here start the pickBonus Fire Fruits
	// then you make this class but change the name for evey game
	class FirePickBonus extends PickBonus
	{
	}


	class FirePickBonusElement extends PickBonusElement
	{
		/* public WaitAnimPick()
		{
			this.anim_waitpick = TweenMax.fromTo(this, 1, {myscale: 1}, {myscale: 1.2, yoyo: true, repeat: -1, ease: Power0.easeNone, paused: true});
		} */
	}


	// class LuckyHotFreegamePickElement extends FreegamePickElement
	// {
	// 	public override AwardElemePrepare()
	// 	{
	// 		super.AwardElemePrepare();
	// 	}

	// 	protected override PreparePickedElement(): void
	// 	{
	// 		this.awardElem.style.color = "yellow";
	// 	}

	// 	protected override PrepareRemainingElement(): void
	// 	{
	// 		this.awardElem.style.removeProperty("color");
	// 	}
	// }


	// ///////**********FREEGAME BONUS**********////
	// ///*************************************** *///
	// class LuckyHotFreegameBonus extends FreegameBonus 
	// {
	// 	public constructor(gameName: string, params: FreegameBonusParams ) {
	// 		super(gameName, params);
	// 		this.spinnableReelsParams.topBorderWidth = 21;
	// 		this.spinnableReelsParams.bottomBorderWidth = 13;
	// 	}

	// 	protected override PicksPositions(): FreegamePickElemGeometry[] 
	// 	{
	// 		let geometry: FreegamePickElemGeometry[] = [];

	// 		let displayWidth: number = 536;
	// 		let displayHeight: number = 382;

	// 		let displayRects: PixelRect[] = 
	// 		[
	// 			new PixelRect(21, 320, displayWidth, displayHeight),
	// 			new PixelRect(363, 640, displayWidth, displayHeight),
	// 			new PixelRect(705, 320, displayWidth, displayHeight),
	// 			new PixelRect(1044, 640, displayWidth, displayHeight),
	// 			new PixelRect(1386, 320, displayWidth, displayHeight),
	// 		];

	// 		// offset relative to pick rect
	// 		//let pickRect = new PixelRect(90, 90, displayWidth - 200, displayHeight - 200);
	// 		let pickRect = new PixelRect(97, 98, 343, 205);
	// 		let awardRect = new PixelRect(40, 65, displayWidth - 100, displayHeight - 100);

	// 		for (let i = 0; i < displayRects.length; i++) 
	// 		{
	// 			geometry.push(new FreegamePickElemGeometry(displayRects[i], pickRect, awardRect));
	// 		}

	// 		return geometry;
	// 	}

	// 	public override OnPicked(index: number): void {
	// 		//super.OnPicked(index);

	// 		if (this.stateMachine.State() == FreegameStates.Pick)
	// 		{
	// 			// Log.Debug(this.logGroup, "Picked index " + index);
	
	// 			// TODO check state, check index bounds
	// 			this.pickedIndex = index;
	// 			// protocol.Send("SelectBonusElement",{selectedElement: index});
	
	// 			for (let i = 0; i < this.picks.length; i++) {
	// 				if (i == index) {
	// 					this.picks[i].BringToFront();
	// 					this.picks[i].awardElem.style.fontSize = "160px";
	// 					this.picks[i].awardElem.style.left = "60px";
	// 					this.picks[i].awardElem.style.top = "45px";
	// 				}
	// 				else {
	// 					this.picks[i].PushToBack();
	// 					this.picks[i].awardElem.style.fontSize = "100px";
	// 					this.picks[i].awardElem.style.left = "60px";
	// 					this.picks[i].awardElem.style.top = "45px";
	// 				}
	// 			}
	
	// 			this.stateMachine.ChangeState(FreegameStates.RevealPicked);
	// 		}
	// 	}
		

	// 	public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>
	// 	{
	// 		await super.ResourcesLoaded(resourceManager);
            
	// 		//this.pickElem.innerHTML = "BOTTLE";


	// 		this.pickIntroMessageContainer.style.color = "yellow";
	// 		this.pickIntroMessageContainer.style.webkitTextStrokeWidth = "2px";
	// 		this.pickIntroMessageContainer.style.webkitTextStrokeColor = "black";
	// 		//this.finalMessageContainer.style.textShadow="black 0px 1px 1px, black 0px 1px 17px, black 0px 1px 21px, black 0px 1px 2px";
			
	// 		this.pickedMessageContainer.style.webkitTextStrokeWidth="2px";
	// 		this.pickedMessageContainer.style.webkitTextStrokeColor = "black"
	// 		//this.pickedMessageContainer.style.textShadow="black 0px 1px 1px, black 0px 1px 17px, black 0px 1px 21px, black 0px 1px 2px";
	// 		this.finalMessageContainer.style.webkitTextStrokeWidth="2px";
	// 		this.finalMessageContainer.style.webkitTextStrokeColor = "black";
	// 		//this.finalMessageContainer.style.textShadow="black 0px 1px 1px, black 0px 1px 17px, black 0px 1px 21px, black 0px 1px 2px";
				
	// 		SetStyles(this.view.querySelectorAll("#startfree3"), { fontSize:"35px" });
	// 		SetStyles(this.view.querySelectorAll("#contents3"), { fontSize:"45px" });
	// 		SetStyles(this.view.querySelectorAll(".header"), { fontSize:"70px" });
	// 		SetStyles(this.view.querySelectorAll(".bonusName"), { fontSize:"60px", lineHeight: "100px", });
	// 		SetStyles(this.view.querySelectorAll("#startfree1"), { fontSize:"40px" });
	// 		SetStyles(this.view.querySelectorAll("#startfree2"), { fontSize:"40px" });
	// 		SetStyles(this.view.querySelectorAll("#contents1"), { fontSize:"50px", lineHeight: "50px" });
	// 		SetStyles(this.view.querySelectorAll("#startfree1"), { fontSize:"50px", lineHeight: "50px" });
	// 		SetStyles(this.view.querySelectorAll("#startfree2"), { fontSize:"50px", lineHeight: "50px" });
	// 		SetStyles(this.view.querySelectorAll("#startfree3"), { fontSize:"50px", lineHeight: "50px" });
	// 		SetStyles(this.view.querySelectorAll("#contents2"), { fontSize:"50px", lineHeight: "50px" });
	// 		SetStyles(this.view.querySelectorAll("#startend32"), { fontSize:"50px", lineHeight: "50px" });
	// 		SetStyles(this.view.querySelectorAll("#headerend"), { fontSize:"73px" });
	// 		SetStyles(this.view.querySelectorAll("#startend3"), { fontSize:"36px" });
			

	// 		// pick instructions on pick screen
	// 		SetStyles(this.view.querySelector(".pickInstructions .pick1"), {lineHeight: "100px"});
	// 	}

	// 	protected override PrepareFonts(resourceManager: ResourceManager): void {
	// 		resourceManager.Add(new FontResource(this.params.gameBonusResourcesBasePath + "huggable.ttf", "." + this.resid.ScopedResourceName("font") ));
	// 		resourceManager.Add(new FontResource(this.params.gameBonusResourcesBasePath + "huggable.ttf", "." + this.resid.ScopedResourceName(["lines", "font"])));
	// 	}
	// }

	//Panel Colorized
	class LuckyHotPanelFactory implements IPanelFactory
	{
		public CreateNewPanel(params: PanelParams):Panel
		{
			return new LuckyHotPanel(params);
		}
	}

	class LuckyHotPanel extends Panel
	{
		protected override ButtonBackground():ButtonColors
		{
			let color:ButtonColors = {
				backgroundButtonColor: "linear-gradient(rgb(38, 15, 15),rgb(89, 14, 14), rgb(140, 15, 15),rgb(89, 14, 14),rgb(38, 15, 15)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
				linearColor:"linear-gradient(to left , transparent, rgb(242, 115, 41),transparent ) 0 10 100%",
			};
			return color;
			
		}

	}

	class LuckyHotHelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new LuckyHotHelp(params);
        }
    }

    class LuckyHotHelp extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(38, 1, 1),rgb(89, 3, 3), rgb(140, 4, 4),rgb(89, 3, 3),rgb(38, 1, 1)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }

	// class LuckyHotFreegameBonusFactory extends FreegameBonusFactory
	// {
	// 	public override CreateFreegameBonus(gameName: string, params: FreegameBonusParams): FreegameBonus 
	// 	{
	// 		return new LuckyHotFreegameBonus(gameName, params);
	// 	}
	// 	public override CreatePickElement(params: FreegamePickElementParams): FreegamePickElement 
	// 	{
	// 		return new LuckyHotFreegamePickElement(params);
	// 	}
	// }

	class LuckyHotPickBonusFactory extends PickBonusFactory
	{
		public override CreatePickBonus(gameName: string, params: PickBonusParams): PickBonus 
		{
			return new FirePickBonus(gameName, params);
		}

		public override CreatePickElement(params: PickBonusPickElementParams): PickBonusElement 
		{
			return new FirePickBonusElement(params);
		}
	}
// }
